/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://efrrd7mrqjgtlgk27ygf2es4kq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:ff27d210-fc47-4bd0-9b17-677658ea4249",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_eI6nSkKai",
    "aws_user_pools_web_client_id": "pvjm01o95u5978k8mcl6hs9fh",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "usermanagementapp77d9772bf1d342f3ae4f49e33ca74091950-ecoplprod",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
